import { Component,OnInit } from '@angular/core';
import { Service } from '../../../../../class/service';
import { Cookies } from '../../../../../class/cookies';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { QuickSearch } from '../../../../../class/search';
import { View } from '../../../view';
import 'rxjs/add/operator/debounceTime';

@Component({
  selector: 'app-bancos',
  templateUrl: './bancos.component.html',
  styleUrls: ['./bancos.component.css']
})
export class BancosComponent extends View implements OnInit {
	//Modelo de datos
	private model: Object = { PKCodigo:'' };
	//Referencia del codigo
	private ref: String = "";
	//Para validaer si el codigo existe
	private validarCodigo: number = 0;
	//relacionado con el imput del html	--llave primaria
	private PKCodigo = new FormControl();
	private existe_pk:boolean = false;
    /*
    == Aqui busquedas rapidas ==
    [quickSearch] -> private qsNombre:QuickSearch;    -> estructura de la busqueda rapida
    [setData]     -> private qsSetNombre:Object;      -> pasar los datos al buscador { key: '',value: ''}
    (getData)     -> private qsGetNombre(rs:Object){} -> funcion para los resultados de la busqueda rapida
     */
	private qsTercero:QuickSearch;
	private qsSetTercero:Object;
	private qsGetTercero(rs:Object){
		console.log(rs);
		//this.model["FKCodigoTercero"] = rs["data"]["codigo"];
	}

	private qsCuenta:QuickSearch;
	private qsSetCuenta:Object;
	private qsGetCuenta(rs:Object){
		console.log(rs);
		//this.model["FKCodigoCuentas"] = rs["data"]["PK_Codigo"];
	}

	constructor(public service: Service, public cookies: Cookies) {
		super(service,cookies,"conta_banco-component");
		super.serviceNmae("banco");
	}

	ngOnInit() {
		super.filter({
			column:[
				{ name: 'PKCodigo', nickname: 'Codigo' },
				{ name: 'nombre', nickname: 'Nombre' }
			]
		});
		/*
		== Aqui inicializar la estructura de la busquedas rapidas ==
			this.qsNombre = {
				label: 'Label',
				required: true || false,
				search: {
					title: 'Title',
					service: 'service',
					column:[
						{
							name: 'nombreBd',
							nickname: 'Nombre',
							visible: true || false
						}
					]
				}
			}
		*/	
		this.qsCuenta = {
			label: 'Cuenta',
			search: {
				title: 'Buscar cuentas',
				service: 'cuentas',
				toSearch: '',
				column:[
					{ name: 'PK_Codigo', nickname: 'Codigo', visible: true },
					{ name: 'Nombre', nickname: 'Nombre', visible: true },
				]
			}
		}
		
		this.qsTercero = {
			label: 'Tercero',
			search: {
				title: 'Buscar tercero',
				service: 'tercero',
				toSearch: '',
				column:[
					{ name: 'codigo', nickname: 'Codigo/NIT', visible: true },
					{ name: 'nombre', nickname: 'Nombre', visible: true },
				]
        	}
      	}	
	}

	//Un nuevo registro, iniciando datos
	private NEW(): void {
		this.PKCodigo.reset();
		this.model = { PKcodigo:'' };
		this.list = false;
		this.action = 'Guardar';
	}

	//Editar en base al codigo de referencia
	private EDIT(codigo: string): void {
		this.ref = codigo;
		this.action = "Actualizar";
		this.list = false;
		this.PKCodigo.disable();
		this.getModelById();
	}

	//Para obtener y cargar el registro seleccionado
	private getModelById(): void {
		this.state = !this.state;
		this.service.GET('banco/' + this.ref, '').subscribe(res => {
			console.log(res);
			this.model = res["show"][0];
			this.qsSetTercero={key:this.model["FKCodigoTercero"],value:''};
			this.qsSetCuenta={key:this.model["FKCodigoCuentas"],value:''};
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
		});
	}

	//Validar si guardar o modificar
	private actionCrud(): void {
		if (this.action.toUpperCase() == "GUARDAR") {
			this.save();
		} else {
			this.update();
		}
	}

	//Para eliminar el registro
	private DELETE(codigo: String): void {
		this.state = !this.state;
		console.log(codigo);
		this.getModelById();
		this.service.DELETE('banco/delete/' + codigo).subscribe(res => {
			this.getList(this.pagination["current_page"], "");
			if (res["destroy"]) {
				this.openMd("El registro se elimino correctamente", "success");
			} else {
				this.openMd("El registro no se elimino", "danger");
			}
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
			this.openMd(err, "danger");
		});
	}

	//Guardar el registro
	private save(): void {
		this.state = !this.state;
        console.log({data: JSON.stringify(this.model)});
		this.model["estado"]=1;
		this.service.POST('banco', { data: JSON.stringify(this.model) }).subscribe(res => {
			this.state = !this.state;
			this.list = !this.list;
			this.getList(1, "");
		}, err => {
			console.log(err);
			this.state = !this.state;
		});
	}

	//Modificar el registro
	private update(): void {
		this.state = !this.state;
		console.log({data: JSON.stringify(this.model) });
		this.service.PUT('banco/update/' + this.ref.trim(), { data: JSON.stringify(this.model) }).subscribe(res => {
			console.log(res);
			if (res["update"]) {
				this.getList(1,"");
				this.state = !this.state;
				this.openMd("El registro se ha modificado correctamente", "success");
				this.list = !this.list;
			} else {
				this.openMd("El registro no se ha podido modificar", "danger");
			}
		}, err => {
			console.log(err);
		});
	}

	//validar codigo
	private validarPk():void{
  		this.service.GET('banco/validarPK/'+this.model["PKCodigo"],'').subscribe(res => {
   		this.existe_pk = res["validarPk"];
		if(this.existe_pk){
			this.openMd('El codigo ingresado ya se encuentra registrado','danger');
		}
  }, err => {
            this.openMd(err,'danger');
  });
 }

}


// WEBPACK FOOTER //
// ./src/app/component/module/archivo/contabilidad/bancos/bancos.component.ts